import { StoreCode } from '@portal/schema/storeCode';
import { SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID } from '@portal/config/base';

export const isAGZSubscriptionVariant = (variantId: string, store: StoreCode) => {
  return (
    (SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].chocolate &&
      variantId.includes(SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].chocolate)) ||
    (SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].chocolateMint &&
      variantId.includes(SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].chocolateMint)) ||
    (SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].mixedBerry &&
      variantId.includes(SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store].mixedBerry))
  );
};
